const workastDataConstants = {
  SET_INITIAL_DATA: 'SET_INITIAL_DATA'
};

export default workastDataConstants;
